import { supabase } from "@/integrations/supabase/client";

// Setup realtime subscriptions for stores, employees and invitations
export const setupRealtimeSubscriptions = (
  fetchEmployees: (storeId: string | null) => Promise<any>,
  fetchInvitations: (storeId: string | null) => Promise<any>,
  fetchStores: () => Promise<void>
) => {
  // Subscribe to stores changes
  const storesChannel = supabase
    .channel("stores_changes")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "stores",
      },
      async (payload) => {
        // Refresh the stores list
        await fetchStores();
      }
    )
    .subscribe();

  // Subscribe to store_employees changes
  const employeesChannel = supabase
    .channel("store_employees_changes")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "store_employees",
      },
      async (payload) => {
        // Refresh the employees list
        await fetchEmployees(null);
      }
    )
    .subscribe();

  // Subscribe to employee_invitations changes
  const invitationsChannel = supabase
    .channel("employee_invitations_changes")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "employee_invitations",
      },
      async (payload) => {
        // Refresh the invitations list
        await fetchInvitations(null);
      }
    )
    .subscribe();

  // Return cleanup function
  return () => {
    supabase.removeChannel(storesChannel);
    supabase.removeChannel(employeesChannel);
    supabase.removeChannel(invitationsChannel);
  };
};
